import React, { PureComponent } from "react";
import classnames from "classnames";
import "./status-indicator.css";

export default class StatusIndicator extends PureComponent {
    static get defaultProps() {
        return {
            size: "1em",
            isActive: true,
        };
    }

    static get propTypes() {
        return {
            size: React.PropTypes.oneOfType([
                React.PropTypes.number,
                React.PropTypes.string,
            ]),
            isActive: React.PropTypes.bool,
        };
    }

    static get contextTypes() {
        return {
            muiTheme: React.PropTypes.object,
        };
    }

    render() {
        const styles = ["appointment-status-indicator"];

        let backgroundColor = "#cddc39";
        if (this.props.isActive === true) {
            styles.push("appointment-status-indicator--active");
        } else {
            styles.push("appointment-status-indicator--inactive");
            backgroundColor = "#f9c4c0";
        }

        return (
            <div className={classnames(styles)} style={{
                width: this.props.size,
                height: this.props.size,
                backgroundColor: backgroundColor
            }}></div>
        );
    }
}


/** WEBPACK FOOTER **
 ** ./src/widgets/appointment-widget/components/status-indicator.js
 **/